// react
import { useState } from 'react';
// @mui
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import InputLabel from '@mui/material/InputLabel';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
// redux
import { useDispatch } from 'src/redux/store';
import { setTaxError } from 'src/redux/slices/tax';
import { setError } from 'src/redux/slices/error';
// localization
import { useLocales } from 'src/locales';
// types
import { ReturnType } from 'src/hooks/use-boolean';
import { ILedgerTableFilters } from '../../types/accounting';
// function
import { FileExportCSV } from './file-export-csv';
import { FileExportSIE } from './file-export-sie';

type props = {
  filters: ILedgerTableFilters;
  openState: ReturnType;
};

export default function FileExportDialog({ filters, openState }: props) {
  const dispatch = useDispatch();

  const [selectedType, setSelectedType] = useState(0);

  const { t } = useLocales();

  const fileType = [
    { name: 'CSV', action: FileExportCSV },
    { name: 'SIE', action: FileExportSIE },
  ];
  const selectPorps = {
    label: t('Please select a file type'),
    name: 'fileType',
  };

  const handleDismiss = () => {
    openState.onFalse();
  };

  const handleSelect = (id: number) => {
    setSelectedType(id);
  };

  const handleExport = async () => {
    try {
      await fileType[selectedType].action(filters);
    } catch (error) {
      if (error.response?.data?.message === 'error.vat.account.number.IsNull') {
        const ids = error.response?.data?.params.split(',') ?? '';
        const detail = error.response?.data?.detail ?? '';

        dispatch(setTaxError({ ids, detail }));
      } else {
        dispatch(setError(error));
      }
    }
    openState.onFalse();
  };

  const renderDialog = (
    <Dialog open={openState.value} onClose={openState.onFalse} slotProps={{}}>
      <DialogTitle>{t('Export file')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('Which file type would you like to export in?')}</DialogContentText>

        <InputLabel id={`label-${selectPorps.name}`}> {selectPorps.label} </InputLabel>
        <Select
          fullWidth
          labelId={`label-${selectPorps.name}`}
          name={selectPorps.name}
          onChange={(opt) => handleSelect(Number(opt.target.value))}
        >
          <MenuItem value="-1" disabled>
            {selectPorps.label}
          </MenuItem>
          {fileType.map((f, index) => (
            <MenuItem key={index} value={index}>
              {t(`${f.name}`)}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleExport}>
          {t('Export')}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return <>{renderDialog}</>;
}
